import { ActionTree } from 'vuex'
import { DocState, RootState } from '@/store/storeTypes'
import StageDescription from '@/ts/model/StageDescription'
import DocApi from '@/ts/apis/DocApi'

const actions: ActionTree<DocState, RootState> = {
  createNew: async ({ commit, state }) => {
    if (state.docState !== 'notexists') {
      return false
    }

    const id = await DocApi.createNewDoc()
    if (!id) {
      return false
    }
    commit('prepare', { id })
    commit('ready', { stage: undefined })
    return true
  },
  listDocs: async ({ commit, state }) => {
    const list = await DocApi.listDocs()
    commit('setUserDocs', { list })
  },
  openDoc: async ({ commit, state }, { id }: { id: string}) => {
    if (state.docState !== 'notexists') {
      return false
    }
    commit('prepare', { id })
    const doc = await DocApi.readDoc(id)
    if (!doc) { return false }
    commit('ready', doc)
    return true
  },
  closeDoc: ({ commit, state }) => {
    if (state.docState !== 'ready') {
      return false
    }
    commit('close')
  },
  saveDoc: async ({ commit, state }, stage: StageDescription) => {
    if (state.docState !== 'ready') {
      return false
    }
    // ask firebase to save doc...
    const id = state.docId
    await DocApi.saveDoc(id, stage)
    commit('setStage', stage)
  },
  orderDoc: async ({ commit, state }, { id, itemType }: { id: string, itemType: string}) => {
    const isOrdered = await DocApi.orderDoc(id, itemType)
    return isOrdered
  },
  cancelOrderDoc: async ({ commit, state }, { id }: { id: string}) => {
    const isSuccess = await DocApi.cancelOrderDoc(id)
    return isSuccess
  },
  deleteDoc: async ({ commit, state }, { id }: { id: string}) => {
    if (!id) {
      return false
    }
    if (id === state.docId) {
      commit('close')
    }
    const isSuccess = await DocApi.deleteDoc(id)
    if (isSuccess) {
      const list = state.userDocs.filter(doc => doc.id !== id)
      commit('setUserDocs', { list })
    }
    return isSuccess
  }
}

export default actions
